import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';

const UPLookupSuggestions = ({ suggestions }) => {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <SrBox padding="10px 22px 14px">
      <SrText
        font="greycliff"
        size="15"
        weight="800"
        color="blueGreycliff"
        display="block"
        marginBottom="8px"
        style={{ textTransform: 'uppercase', letterSpacing: '0.06em' }}
      >
        Lookup Suggestions
      </SrText>
      {suggestions.map((suggestion) => {
        const confidencePct = Math.round((suggestion.confidence || 0) * 100);
        const isHighConfidence = confidencePct >= 75;

        return (
          <SrBox
            key={suggestion.id}
            border="1px solid #e2e8f0"
            borderRadius="6px"
            padding="8px 12px"
            marginBottom="6px"
            backgroundColor="#f8fafc"
          >
            <SrFlex justify="between" align="center">
              <SrFlex align="center" columnGap="6px">
                <SrText font="greycliff" size="13" weight="600" color="blueGreycliff">
                  {suggestion.providerName}
                </SrText>
                {suggestion.isPrimary && (
                  <SrBox backgroundColor="#dbeafe" borderRadius="3px" padding="1px 5px">
                    <SrText font="greycliff" size="10" weight="700" color="blue300">
                      PRIMARY
                    </SrText>
                  </SrBox>
                )}
              </SrFlex>
              <SrBox
                backgroundColor={isHighConfidence ? '#dcfce7' : '#fef9c3'}
                borderRadius="12px"
                padding="2px 8px"
              >
                <SrText
                  font="greycliff"
                  size="11"
                  weight="600"
                  color={isHighConfidence ? 'green' : 'gold'}
                >
                  {confidencePct}%
                </SrText>
              </SrBox>
            </SrFlex>
            {(suggestion.phone || suggestion.website) && (
              <SrText
                font="greycliff"
                size="12"
                color="blueGreycliff"
                display="block"
                marginTop="3px"
              >
                {[suggestion.phone, suggestion.website].filter(Boolean).join(' · ')}
              </SrText>
            )}
          </SrBox>
        );
      })}
    </SrBox>
  );
};

UPLookupSuggestions.propTypes = {
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      providerName: PropTypes.string.isRequired,
      confidence: PropTypes.number,
      isPrimary: PropTypes.bool,
      phone: PropTypes.string,
      website: PropTypes.string,
      utilityTypeId: PropTypes.number,
    }),
  ),
};

UPLookupSuggestions.defaultProps = {
  suggestions: [],
};

UPLookupSuggestions.displayName = 'UPLookupSuggestions';

export default UPLookupSuggestions;
